module.exports = __webpack_public_path__ + "static/img/jiguang.dfcaba7d.png";